(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["daymoon-product-rail"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-daymoon-drag-rail]:not([data-drag-ready])').forEach((track) => {
    track.dataset.dragReady = 'true';
    let pointerId = null;
    let startX = 0;
    let startScrollLeft = 0;
    let dragged = false;

    track.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScrollLeft = track.scrollLeft;
      dragged = false;
      track.classList.add('is-dragging');
      track.setPointerCapture(pointerId);
    });

    track.addEventListener('pointermove', (event) => {
      if (event.pointerId !== pointerId) return;
      const distance = event.clientX - startX;
      if (Math.abs(distance) > 5) dragged = true;
      track.scrollLeft = startScrollLeft - distance;
    });

    const finishDrag = (event) => {
      if (event.pointerId !== pointerId) return;
      if (track.hasPointerCapture(pointerId)) track.releasePointerCapture(pointerId);
      pointerId = null;
      track.classList.remove('is-dragging');
    };

    track.addEventListener('pointerup', finishDrag);
    track.addEventListener('pointercancel', finishDrag);
    track.addEventListener('click', (event) => {
      if (!dragged) return;
      event.preventDefault();
      event.stopPropagation();
      dragged = false;
    }, true);
    track.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      const direction = event.key === 'ArrowRight' ? 1 : -1;
      track.scrollBy({ left: track.clientWidth * 0.72 * direction, behavior: 'smooth' });
    });

    const viewport = track.closest('.daymoon-rail__viewport');
    viewport?.querySelector('[data-daymoon-rail-prev]')?.addEventListener('click', () => {
      track.scrollBy({ left: -track.clientWidth * 0.72, behavior: 'smooth' });
    });
    viewport?.querySelector('[data-daymoon-rail-next]')?.addEventListener('click', () => {
      track.scrollBy({ left: track.clientWidth * 0.72, behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["daymoon-product"] && !Shopify.designMode) return;
  try {
    
  const daymoonProducts = document.querySelectorAll('[data-daymoon-product]:not([data-daymoon-ready])');

  daymoonProducts.forEach((root) => {
    root.dataset.daymoonReady = 'true';
    const variantsNode = root.querySelector('[data-product-variants]');
    const optionSelects = Array.from(root.querySelectorAll('[data-product-option]'));
    const optionCards = Array.from(root.querySelectorAll('[data-option-card]'));
    const variantInput = root.querySelector('[data-daymoon-variant-input]');
    const productForm = root.querySelector('.daymoon-product__form');
    const submitPrice = root.querySelector('[data-submit-price]');
    const submitButton = root.querySelector('.daymoon-product__submit');
    const submitLabel = root.querySelector('[data-submit-label]');
    const galleryItems = Array.from(root.querySelectorAll('[data-gallery-item]'));
    const galleryThumbs = Array.from(root.querySelectorAll('[data-gallery-thumb]'));
    const gallery = root.querySelector('[data-gallery]');
    const desktopGalleryAnchor = root.querySelector('[data-gallery-desktop-anchor]');
    const mobileGalleryAnchor = root.querySelector('[data-mobile-gallery-anchor]');
    const descriptionDisclosure = root.querySelector('[data-description-disclosure]');
    const optionsDisclosure = root.querySelector('[data-options-disclosure]');
    const selectionSummary = root.querySelector('[data-selection-summary]');
    const dynamicCheckout = root.querySelector('[data-dynamic-checkout]');
    const mobileMedia = window.matchMedia('(max-width: 749px)');
    let variants = [];
    let descriptionWasToggled = false;

    galleryThumbs.forEach((thumb, index) => {
      thumb.dataset.originalOrder = String(index);
    });

    if (variantsNode && variantsNode.textContent.trim()) {
      try {
        variants = JSON.parse(variantsNode.textContent);
      } catch (error) {
        variants = [];
      }
    }

    const scopeFromValue = (value) => {
      const normalized = String(value || '').toLowerCase();
      if (normalized.includes('magsafe')) return 'magsafe';
      if (normalized.includes('single')) return 'single';
      return 'dual';
    };

    const getCaseSelect = () => optionSelects.find((select) => select.dataset.optionName.includes('case'));
    const getCaseScope = () => {
      const caseSelect = getCaseSelect();
      return caseSelect ? scopeFromValue(caseSelect.value) : root.dataset.initialCase || 'dual';
    };
    const normalizeModel = (value) =>
      String(value || '')
        .toLowerCase()
        .normalize('NFKD')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    const getModelSelect = () =>
      optionSelects.find(
        (select) => !select.dataset.optionName.includes('case') &&
          (select.dataset.optionName.includes('phone') || select.dataset.optionName.includes('model')),
      );
    const getSelectedModelHandle = () => {
      const modelSelect = getModelSelect();
      return normalizeModel(modelSelect ? modelSelect.value : root.dataset.initialModel);
    };
    const getModelScope = () => {
      const modelScope = getSelectedModelHandle();
      const modelAliases = {
        'iphone-13': 'iphone-14',
        'iphone-15-plus': 'iphone-14-plus',
        'iphone-18-pro': 'iphone-17-pro',
        'iphone-18-pro-max': 'iphone-17-pro-max',
      };
      return modelAliases[modelScope] || modelScope;
    };
    const modelFromMedia = (element) => {
      const match = String(element.dataset.mediaTags || '').toLowerCase().match(/\[model:([^\]]+)\]/);
      return match ? match[1] : 'all';
    };
    const visibleForSelection = (
      element,
      caseScope,
      modelScope,
      selectedModelHandle,
      preferredMediaId,
      duplicateMediaId,
    ) => {
      if (duplicateMediaId && element.dataset.mediaId === duplicateMediaId) return false;
      if (preferredMediaId && element.dataset.mediaId === String(preferredMediaId)) return true;
      const mediaCase = element.dataset.case || 'all';
      const mediaModel = modelFromMedia(element);
      const isSideView = /(?:left|right) side/i.test(element.dataset.mediaTags || '');
      const caseMatches = element.dataset.mediaRole === 'model'
        ? mediaCase === caseScope
        : mediaCase === 'all' || mediaCase === caseScope || (caseScope === 'magsafe' && mediaCase === 'dual');
      const modelMatches = mediaModel === 'all' || mediaModel === modelScope;
      return caseMatches && modelMatches;
    };

    const updateCaseCards = () => {
      const caseSelect = getCaseSelect();
      optionCards.forEach((card) => {
        const active = card.dataset.optionValue === caseSelect?.value;
        card.classList.toggle('is-active', active);
        card.setAttribute('aria-pressed', String(active));
        const cardOptions = optionSelects
          .sort((left, right) => Number(left.dataset.optionPosition) - Number(right.dataset.optionPosition))
          .map((select) => {
            if (select === caseSelect) return card.dataset.optionValue;
            return select.value || Array.from(select.options).find((option) => option.value)?.value || '';
          });
        const cardVariant = variants.find((candidate) =>
          candidate.options.every((option, index) => option === cardOptions[index]),
        );
        const price = card.querySelector('[data-case-price]');
        if (price) price.textContent = cardVariant ? formatMoney(cardVariant.price) : '';
      });
    };

    const activateMedia = (caseScope, modelScope, selectedModelHandle, preferredMediaId) => {
      const selectedModelItem = galleryItems.find(
        (item) => item.dataset.mediaRole === 'model' && modelFromMedia(item) === modelScope &&
          item.dataset.case === caseScope,
      );
      const genericFrontItem = selectedModelItem
        ? galleryItems.find(
            (item) => item.dataset.mediaRole === 'product' &&
              (item.dataset.case === caseScope || (caseScope === 'magsafe' && item.dataset.case === 'dual')),
          )
        : null;
      const duplicateMediaId = genericFrontItem?.dataset.mediaId || '';

      galleryItems.forEach((item) => {
        item.hidden = !visibleForSelection(
          item,
          caseScope,
          modelScope,
          selectedModelHandle,
          preferredMediaId,
          duplicateMediaId,
        );
        item.classList.remove('is-active');
      });
      galleryThumbs.forEach((thumb) => {
        thumb.hidden = !visibleForSelection(
          thumb,
          caseScope,
          modelScope,
          selectedModelHandle,
          preferredMediaId,
          duplicateMediaId,
        );
        thumb.classList.remove('is-active');
        const tags = thumb.dataset.mediaTags || '';
        if (thumb.dataset.mediaId === selectedModelItem?.dataset.mediaId) {
          thumb.style.order = '-10';
        } else if (/left side/i.test(tags)) {
          thumb.style.order = '0';
        } else if (/right side/i.test(tags)) {
          thumb.style.order = '1';
        } else {
          thumb.style.order = String(Number(thumb.dataset.originalOrder || 0) + 10);
        }
      });

      let target = selectedModelItem && !selectedModelItem.hidden ? selectedModelItem : null;
      if (preferredMediaId) {
        target ||= galleryItems.find((item) => item.dataset.mediaId === String(preferredMediaId) && !item.hidden);
      }
      target ||= galleryItems.find((item) => !item.hidden);
      if (!target) return;

      target.classList.add('is-active');
      const activeThumb = galleryThumbs.find((thumb) => thumb.dataset.mediaId === target.dataset.mediaId);
      activeThumb?.classList.add('is-active');
    };

    const formatMoney = (amount) => {
      const currency = root.dataset.currency || 'USD';
      const value = (Number(amount) || 0) / 100;
      if (currency === 'USD') {
        return 'US$' + value.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency,
        currencyDisplay: 'code',
      }).format(value);
    };

    const syncVariantInput = (variant) => {
      if (!variantInput || !variant) return;
      const variantId = String(variant.id);
      variantInput.value = variantId;
      variantInput.defaultValue = variantId;
      variantInput.setAttribute('value', variantId);
    };

    const updateVariant = () => {
      const selectedOptions = [...optionSelects]
        .sort((left, right) => Number(left.dataset.optionPosition) - Number(right.dataset.optionPosition))
        .map((select) => select.value);
      const variant = variants.find((candidate) =>
        candidate.options.every((option, index) => option === selectedOptions[index]),
      );
      const caseScope = getCaseScope();
      const selectedModelHandle = getSelectedModelHandle();
      const modelScope = getModelScope();
      const modelSelect = getModelSelect();
      const hasConfirmedModel = !modelSelect || Boolean(modelSelect.value);
      updateCaseCards();
      if (selectionSummary) {
        selectionSummary.textContent = hasConfirmedModel
          ? `${modelSelect?.value || ''} · ${getCaseSelect()?.value || ''}`
          : selectionSummary.dataset.chooseLabel;
      }

      if (!hasConfirmedModel) {
        if (submitButton) submitButton.disabled = true;
        if (dynamicCheckout) dynamicCheckout.hidden = true;
        activateMedia(caseScope, root.dataset.initialModel, root.dataset.initialModel);
        return;
      }

      if (!variant) {
        if (submitButton) submitButton.disabled = true;
        activateMedia(caseScope, modelScope, selectedModelHandle);
        return;
      }

      syncVariantInput(variant);
      if (submitPrice) submitPrice.textContent = formatMoney(variant.price);
      if (submitButton && submitLabel) {
        submitButton.disabled = !variant.available;
        submitLabel.textContent = variant.available ? submitButton.dataset.addLabel : submitButton.dataset.soldLabel;
      }
      if (dynamicCheckout) dynamicCheckout.hidden = !variant.available;
      activateMedia(caseScope, modelScope, selectedModelHandle, variant.featured_media?.id);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    optionSelects.forEach((select) => select.addEventListener('change', () => {
      updateVariant();
      if (mobileMedia.matches && optionsDisclosure) optionsDisclosure.open = false;
    }));
    optionCards.forEach((card) => {
      card.addEventListener('click', () => {
        const select = optionSelects.find((candidate) => candidate.dataset.optionPosition === card.dataset.optionPosition);
        if (!select) return;
        select.value = card.dataset.optionValue;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    productForm?.addEventListener('submit', () => {
      const selectedOptions = [...optionSelects]
        .sort((left, right) => Number(left.dataset.optionPosition) - Number(right.dataset.optionPosition))
        .map((select) => select.value);
      const variant = variants.find((candidate) =>
        candidate.options.every((option, index) => option === selectedOptions[index]),
      );
      if (!variant) return;
      syncVariantInput(variant);
    }, true);
    galleryThumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const targetId = thumb.dataset.mediaId;
        galleryItems.forEach((item) => item.classList.toggle('is-active', item.dataset.mediaId === targetId));
        galleryThumbs.forEach((item) => item.classList.toggle('is-active', item === thumb));
      });
    });

    const syncMobileLayout = () => {
      if (gallery && mobileGalleryAnchor && desktopGalleryAnchor) {
        if (mobileMedia.matches) {
          mobileGalleryAnchor.after(gallery);
        } else {
          desktopGalleryAnchor.after(gallery);
        }
      }
      if (descriptionDisclosure && !descriptionWasToggled) {
        descriptionDisclosure.open = !mobileMedia.matches;
      }
      if (optionsDisclosure) optionsDisclosure.open = !mobileMedia.matches;
    };

    descriptionDisclosure?.querySelector('summary')?.addEventListener('click', () => {
      descriptionWasToggled = true;
    });
    mobileMedia.addEventListener('change', syncMobileLayout);
    syncMobileLayout();

    if (root.dataset.hasSelectedVariant !== 'true') {
      const caseSelect = getCaseSelect();
      const preferredCase = Array.from(caseSelect?.options || []).find((option) => {
        const value = option.value.toLowerCase();
        return value.includes('dual') && !value.includes('magsafe');
      });
      if (preferredCase) caseSelect.value = preferredCase.value;
    }

    updateVariant();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["daymoon-split-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-daymoon-hero-track]:not([data-hero-ready])').forEach((track) => {
    track.dataset.heroReady = 'true';
    const dots = Array.from(track.parentElement.querySelectorAll('[data-daymoon-hero-dot]'));
    if (dots.length < 2) return;

    let frame = null;
    track.addEventListener('scroll', () => {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
      });
    }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["daymoon-wide-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-daymoon-carousel]:not([data-carousel-ready])').forEach((root) => {
    root.dataset.carouselReady = 'true';
    const track = root.querySelector('[data-carousel-track]');
    const slides = Array.from(root.querySelectorAll('[data-carousel-slide]'));
    const dots = Array.from(root.querySelectorAll('.daymoon-wide-carousel__dots i'));
    const goTo = (index) => {
      if (!track || !slides.length) return;
      const normalized = (index + slides.length) % slides.length;
      track.scrollTo({ left: slides[normalized].offsetLeft, behavior: 'smooth' });
    };
    const activeIndex = () => {
      if (!track || !slides.length) return 0;
      return slides.reduce((best, slide, index) => {
        const distance = Math.abs(slide.offsetLeft - track.scrollLeft);
        return distance < best.distance ? { index, distance } : best;
      }, { index: 0, distance: Infinity }).index;
    };
    const updateDots = () => {
      const current = activeIndex();
      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === current));
    };
    root.querySelector('[data-carousel-previous]')?.addEventListener('click', () => goTo(activeIndex() - 1));
    root.querySelector('[data-carousel-next]')?.addEventListener('click', () => goTo(activeIndex() + 1));
    track?.addEventListener('scroll', updateDots, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.daymoonHomeMode = this.classList.contains('header-wrapper--daymoon-home');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      if (this.daymoonHomeMode) {
        this.header.classList.toggle('scrolled-past-header', window.scrollY > 24);
      }

      this.setupDeviceMenuHover();
      this.createObserver();
    }

    setupDeviceMenuHover() {
      this.deviceMenu = this.querySelector('.daymoon-device-menu');
      if (!this.deviceMenu) return;

      this.deviceMenuHoverArea = this.deviceMenu.closest('header-menu') || this.deviceMenu;
      this.deviceMenuSummary = this.deviceMenu.querySelector('summary');
      this.deviceMenuContent = this.deviceMenu.querySelector('.daymoon-device-menu__content');
      this.positionDeviceMenu = () => {
        if (!this.deviceMenuContent) return;
        document.documentElement.style.setProperty(
          '--header-bottom-position-desktop',
          `${Math.floor(this.getBoundingClientRect().bottom)}px`
        );
      };
      this.openDeviceMenu = () => {
        if (!window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;
        window.clearTimeout(this.deviceMenuCloseTimer);
        this.positionDeviceMenu();
        this.deviceMenu.setAttribute('open', '');
        this.deviceMenuSummary?.setAttribute('aria-expanded', 'true');
      };
      this.closeDeviceMenu = () => {
        if (!window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;
        window.clearTimeout(this.deviceMenuCloseTimer);
        this.deviceMenuCloseTimer = window.setTimeout(() => {
          this.deviceMenu.removeAttribute('open');
          this.deviceMenuSummary?.setAttribute('aria-expanded', 'false');
        }, 350);
      };

      this.deviceMenuHoverArea.addEventListener('mouseenter', this.openDeviceMenu);
      this.deviceMenuHoverArea.addEventListener('mouseleave', this.closeDeviceMenu);
      window.addEventListener('resize', this.positionDeviceMenu);
      this.positionDeviceMenu();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.clearTimeout(this.deviceMenuCloseTimer);
      this.deviceMenuHoverArea?.removeEventListener('mouseenter', this.openDeviceMenu);
      this.deviceMenuHoverArea?.removeEventListener('mouseleave', this.closeDeviceMenu);
      window.removeEventListener('resize', this.positionDeviceMenu);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.daymoonHomeMode) {
        this.header.classList.toggle('scrolled-past-header', scrollTop > 24);
      }

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
